export function extractContactFromResponse(accepted, response) {
  if (!accepted || !response) return null;
  const contact = response.responseUnsafe?.contact ?? response.contact;
  return contact?.phone_number ? contact : null;
}
